import axios from "axios";

const ACCESS = "as_access_token";
const REFRESH = "as_refresh_token";
const REMEMBER = "as_remember";

export const tokenStore = {
  get access() { return sessionStorage.getItem(ACCESS) || localStorage.getItem(ACCESS); },
  get refresh() { return sessionStorage.getItem(REFRESH) || localStorage.getItem(REFRESH); },
  get remember() { return localStorage.getItem(REMEMBER) !== "0"; },
  set(access, refresh, remember) {
    const persist = remember === undefined ? this.remember : remember;
    const target = persist ? localStorage : sessionStorage;
    const other = persist ? sessionStorage : localStorage;
    if (access) { target.setItem(ACCESS, access); other.removeItem(ACCESS); }
    if (refresh) { target.setItem(REFRESH, refresh); other.removeItem(REFRESH); }
    if (remember !== undefined) localStorage.setItem(REMEMBER, remember ? "1" : "0");
  },
  clear() { [localStorage, sessionStorage].forEach((s) => { s.removeItem(ACCESS); s.removeItem(REFRESH); }); },
};

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = tokenStore.access;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    const noRefresh = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password"];
    if (error.response?.status === 401 && !original._retry && !noRefresh.some((p) => url.includes(p))) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`,
            {},
            { withCredentials: true, headers: tokenStore.refresh ? { Authorization: `Bearer ${tokenStore.refresh}` } : {} }
          ).finally(() => { refreshing = null; });
        }
        const { data } = await refreshing;
        if (data?.access_token) { tokenStore.set(data.access_token, null); }
        original.headers = original.headers || {};
        if (data?.access_token) original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        tokenStore.clear();
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Niečo sa pokazilo. Skúste znova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function eur(n) {
  return new Intl.NumberFormat("sk-SK", { style: "currency", currency: "EUR" }).format(Number(n || 0));
}

export default api;
